import { BaseSyntheticEvent, FC, useEffect, useState } from 'react'
import { Input } from '../Input/Input'
import Swal from 'sweetalert2'
import { LittleButton } from '../Button/LittleButton'
import usePluginsSpace from '../../hooks/usePluginSpace'
import { ModalWrapper } from '../Modals/General/ModalWrapper/ModalWrapper'
import useModals from '../../hooks/useModals'
import { Loading } from '../../components/Loading/Loading'

type Props = {
  next: () => void
  back: () => void
  data: any
  setData: (value: any) => any
}

type CardProduct = {
  image?: File | null | string | undefined
  value?: string
  description?: string
  urlExternal?: string
}

type ImageLoadingState = {
  principal: boolean
  cardOne: boolean
  cardTwo: boolean
  cardThree: boolean
  cardFour: boolean
  cardFive: boolean
  product0: boolean
  product1: boolean
  product2: boolean
  product3: boolean
  product4: boolean
}

const ImagensLoja: FC<Props> = ({ next, back, data, setData }) => {
  const [imagePricipal, setImagePrincipal] = useState<File | null | string>()
  const [imageCardOne, setImageCardOne] = useState<File | null | string>()
  const [imageCardTwo, setImageCardTwo] = useState<File | null | string>()
  const [imageCardThree, setImageCardThree] = useState<File | null | string>()
  const [imageCardFour, setImageCardFour] = useState<File | null | string>()
  const [imageCardFive, setImageCardFive] = useState<File | null | string>()
  const [cardsProduct, setCardsProduct] = useState<CardProduct[]>([])

  const [cardProduct, setCardProduct] = useState<CardProduct>({})
  const [cardProductIndex, setCardProductIndex] = useState<number>(0)

  const { pluginSpace } = usePluginsSpace()
  const { showWrapperModal } = useModals()
  const [hasProductCard, setHasProductCard] = useState<boolean>(false)

  const [isLoading, setIsLoading] = useState<boolean>(false)
  
  const [imageLoadingState, setImageLoadingState] = useState<ImageLoadingState>({
    principal: false,
    cardOne: false,
    cardTwo: false,
    cardThree: false,
    cardFour: false,
    cardFive: false,
    product0: false,
    product1: false,
    product2: false,
    product3: false,
    product4: false,
  })

  // Função para atualizar estado de loading de uma imagem
  const setImageLoading = (imageKey: keyof ImageLoadingState, isLoading: boolean) => {
    setImageLoadingState(prev => ({
      ...prev,
      [imageKey]: isLoading
    }))
  }

  // Componente de overlay de carregamento
  const ImageLoadingOverlay = ({ isLoading }: { isLoading: boolean }) => {
    if (!isLoading) return null
    return (
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(255, 255, 255, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '4px',
          zIndex: 100,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <div
            style={{
              width: '30px',
              height: '30px',
              border: '3px solid #f3f3f3',
              borderTop: '3px solid #6993ff',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
            }}
          />
          <small style={{ color: '#677484', fontSize: '12px' }}>Carregando...</small>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    )
  }

  function showImages() {
    try {
      // Definir todas como carregando inicialmente
      setImageLoadingState({
        principal: true,
        cardOne: true,
        cardTwo: true,
        cardThree: true,
        cardFour: true,
        cardFive: true,
        product0: true,
        product1: true,
        product2: true,
        product3: true,
        product4: true,
      })

      if (data.config.images) {
        setImageCardOne(data.config.images[0]?.image)
        setImageCardTwo(data.config.images[1]?.image)
        setImageCardThree(data.config.images[2]?.image)
        setImageCardFour(data.config.images[3]?.image)
        setImageCardFive(data.config.images[4]?.image)
      }

      if (data.config.product) {
        setCardsProduct(data.config.product)
      }

      setImagePrincipal(data.image)

      if (pluginSpace && pluginSpace.detail && pluginSpace.detail.theme === 2) {
        setHasProductCard(true)
      }

      // Simular carregamento das imagens (em casos reais, isso é feito pelo onLoad do img)
      setTimeout(() => {
        setImageLoadingState({
          principal: false,
          cardOne: false,
          cardTwo: false,
          cardThree: false,
          cardFour: false,
          cardFive: false,
          product0: false,
          product1: false,
          product2: false,
          product3: false,
          product4: false,
        })
      }, 1000)
    } catch (error) {
      console.log(error)
      // Desligar loading em caso de erro
      setImageLoadingState({
        principal: false,
        cardOne: false,
        cardTwo: false,
        cardThree: false,
        cardFour: false,
        cardFive: false,
        product0: false,
        product1: false,
        product2: false,
        product3: false,
        product4: false,
      })
    }
  }

  function nextPage() {
    if (
      !imageCardOne ||
      !imageCardTwo ||
      !imageCardThree ||
      !imageCardFour ||
      !imageCardFive ||
      !imagePricipal
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Verifique os campos faltantes',
      })
      return
    }
    const newData = data

    const images = [
      { image: imageCardOne },
      { image: imageCardTwo },
      { image: imageCardThree },
      { image: imageCardFour },
      { image: imageCardFive },
    ]

    newData.config.images = images
    newData.config.product = cardsProduct
    newData.image = imagePricipal

    setData(newData)
    next()
  }

  function backPage() {
    const newData = data

    const images = [
      { image: imageCardOne },
      { image: imageCardTwo },
      { image: imageCardThree },
      { image: imageCardFour },
      { image: imageCardFive },
    ]

    newData.config.images = images
    newData.image = imagePricipal

    setData(newData)
    back()
  }

  useEffect(() => {
    showImages()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const validateUrl = (url: string) => {
    if (!url) return true // Campo não obrigatório
    return url.startsWith('http://') || url.startsWith('https://')
  }

  return (
    <>
      {isLoading ? (
        <>
          <Loading />
        </>
      ) : (
          <div className='card mt-5' style={{ padding: '2rem 5rem' }}>
            <div>
              <h3>Imagens da Loja </h3>
              <span>Aqui você configura as imagens da loja .</span>
            </div>

            <div className='row ' style={{ marginTop: '14px' }}>
              <div className='col-2 d-flex flex-column border-end' style={{ gap: '16px' }}>
                <span
                  style={{
                    color: '#677484',
                    fontWeight: '600',
                  }}
                >
                  Imagem - Card da Loja
              </span>
                <div style={{ position: 'relative' }}>
                  <Input
                    inputAttr={{
                      type: 'image',
                    }}
                    imagemBackgroundDefault={'340x340'}
                    width='100'
                    height='100'
                    value={imagePricipal}
                    change={(value: BaseSyntheticEvent) => {
                      const file = value ? value.target.files[0] : null;
                      const sizeInBytes: number = file ? file.size : 0;

                      const sizeInKB = parseFloat((sizeInBytes / 1024).toFixed(2));
                      const sizeInMB = parseFloat((sizeInKB / 1024).toFixed(2));

                      if (sizeInMB > 2) {
                        Swal.fire({
                          icon: 'error',
                          title: 'Erro',
                          text: 'O tamanho do arquivo excede 2MB. Por favor, selecione um arquivo menor.',
                        });
                        return;
                      }

                      setImageLoading('principal', true)
                      setImagePrincipal(value ? value.target.files[0] : null)
                      setTimeout(() => setImageLoading('principal', false), 500)
                    }}
                  />
                  <ImageLoadingOverlay isLoading={imageLoadingState.principal} />
                </div>
              </div>

              <div className='col-7 d-flex flex-column' style={{ gap: '16px' }}>
                <span
                  style={{
                    color: '#677484',
                    fontWeight: '600',
                  }}
                >
                  Imagem - Card da Loja
              </span>

                <div className='d-flex gap-5 justify-content-center flex-wrap'>
                  <div style={{ position: 'relative' }}>
                    <Input
                      inputAttr={{
                        type: 'image',
                      }}
                      width='200'
                      height='150'
                      imagemBackgroundDefault={'640x240'}
                      value={imageCardOne}
                      change={(value: BaseSyntheticEvent) => {
                        const file = value ? value.target.files[0] : null;
                        const sizeInBytes: number = file ? file.size : 0;

                        const sizeInKB = parseFloat((sizeInBytes / 1024).toFixed(2));
                        const sizeInMB = parseFloat((sizeInKB / 1024).toFixed(2));

                        if (sizeInMB > 2) {
                          Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'O tamanho do arquivo excede 2MB. Por favor, selecione um arquivo menor.',
                          });
                          return;
                        }

                        setImageLoading('cardOne', true)
                        setImageCardOne(value ? value.target.files[0] : null)
                        setTimeout(() => setImageLoading('cardOne', false), 500)
                      }}
                    />
                    <ImageLoadingOverlay isLoading={imageLoadingState.cardOne} />
                  </div>
                  <div style={{ position: 'relative' }}>
                    <Input
                      inputAttr={{
                        type: 'image',
                      }}
                      width='200'
                      height='150'
                      imagemBackgroundDefault={'640x240'}
                      value={imageCardTwo}
                      change={(value: BaseSyntheticEvent) => {
                        const file = value ? value.target.files[0] : null;
                        const sizeInBytes: number = file ? file.size : 0;

                        const sizeInKB = parseFloat((sizeInBytes / 1024).toFixed(2));
                        const sizeInMB = parseFloat((sizeInKB / 1024).toFixed(2));

                        if (sizeInMB > 2) {
                          Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'O tamanho do arquivo excede 2MB. Por favor, selecione um arquivo menor.',
                          });
                          return;
                        }
                        setImageLoading('cardTwo', true)
                        setImageCardTwo(value ? value.target.files[0] : null)
                        setTimeout(() => setImageLoading('cardTwo', false), 500)
                      }}
                    />
                    <ImageLoadingOverlay isLoading={imageLoadingState.cardTwo} />
                  </div>
                  <div style={{ position: 'relative' }}>
                    <Input
                      inputAttr={{
                        type: 'image',
                      }}
                      width='200'
                      height='150'
                      imagemBackgroundDefault={'640x240'}
                      value={imageCardThree}
                      change={(value: BaseSyntheticEvent) => {
                        const file = value ? value.target.files[0] : null;
                        const sizeInBytes: number = file ? file.size : 0;

                        const sizeInKB = parseFloat((sizeInBytes / 1024).toFixed(2));
                        const sizeInMB = parseFloat((sizeInKB / 1024).toFixed(2));

                        if (sizeInMB > 2) {
                          Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'O tamanho do arquivo excede 2MB. Por favor, selecione um arquivo menor.',
                          });
                          return;
                        }
                        setImageLoading('cardThree', true)
                        setImageCardThree(value ? value.target.files[0] : null)
                        setTimeout(() => setImageLoading('cardThree', false), 500)
                      }}
                    />
                    <ImageLoadingOverlay isLoading={imageLoadingState.cardThree} />
                  </div>
                  <div style={{ position: 'relative' }}>
                    <Input
                      inputAttr={{
                        type: 'image',
                      }}
                      width='200'
                      imagemBackgroundDefault={'640x240'}
                      height='150'
                      value={imageCardFour}
                      change={(value: BaseSyntheticEvent) => {
                        const file = value ? value.target.files[0] : null;
                        const sizeInBytes: number = file ? file.size : 0;

                        const sizeInKB = parseFloat((sizeInBytes / 1024).toFixed(2));
                        const sizeInMB = parseFloat((sizeInKB / 1024).toFixed(2));

                        if (sizeInMB > 2) {
                          Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'O tamanho do arquivo excede 2MB. Por favor, selecione um arquivo menor.',
                          });
                          return;
                        }
                        setImageLoading('cardFour', true)
                        setImageCardFour(value ? value.target.files[0] : null)
                        setTimeout(() => setImageLoading('cardFour', false), 500)
                      }}
                    />
                    <ImageLoadingOverlay isLoading={imageLoadingState.cardFour} />
                  </div>
                  <div style={{ position: 'relative' }}>
                    <Input
                      inputAttr={{
                        type: 'image',
                      }}
                      width='200'
                      imagemBackgroundDefault={'640x240'}
                      height='150'
                      value={imageCardFive}
                      change={(value: BaseSyntheticEvent) => {
                        const file = value ? value.target.files[0] : null;
                        const sizeInBytes: number = file ? file.size : 0;

                        const sizeInKB = parseFloat((sizeInBytes / 1024).toFixed(2));
                        const sizeInMB = parseFloat((sizeInKB / 1024).toFixed(2));

                        if (sizeInMB > 2) {
                          Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'O tamanho do arquivo excede 2MB. Por favor, selecione um arquivo menor.',
                          });
                          return;
                        }

                        setImageLoading('cardFive', true)
                        setImageCardFive(value ? value.target.files[0] : null)
                        setTimeout(() => setImageLoading('cardFive', false), 500)
                      }}
                    />
                    <ImageLoadingOverlay isLoading={imageLoadingState.cardFive} />
                  </div>
                </div>
              </div>
              <div className='col-3 d-flex flex-column justify-content-between'>
                <div className='position-relative'>
                  {!hasProductCard && (
                    <div
                      className='position-absolute w-100 h-100'
                      style={{
                        zIndex: 9999,
                        background: 'rgba(250,250,250,0.6)',
                      }}
                    ></div>
                  )}
                  <span
                    style={{
                      color: '#677484',
                      fontWeight: '600',
                    }}
                  >
                    Imagem - Card do Produto
                </span>
                  <div className='d-flex gap-5 justify-content-center flex-wrap'>
                    <div style={{ position: 'relative' }}>
                      <Input
                        inputAttr={{
                          type: 'image_modal',
                        }}
                        disabled={hasProductCard}
                        width='100'
                        height='100'
                        imagemBackgroundDefault={'340x340'}
                        value={cardsProduct[0] && cardsProduct[0].image ? cardsProduct[0].image : null}
                        change={(value: any) => {
                          Swal.fire({
                            title: 'Deseja Remover produto?',
                            text: '',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Sim, remover!',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setIsLoading(true)
                              cardsProduct[0] = {
                                image: '',
                                value: '',
                                description: '',
                              }
                              setTimeout(() => setIsLoading(false), 500)
                            }
                          })
                        }}
                        action={() => {
                          showWrapperModal('Imagem - Card Produto')
                          setCardProduct(cardsProduct[0])
                          setCardProductIndex(0)
                        }}
                      />
                      <ImageLoadingOverlay isLoading={imageLoadingState.product0} />
                    </div>
                    <div style={{ position: 'relative' }}>
                      <Input
                        inputAttr={{
                          type: 'image_modal',
                        }}
                        disabled={hasProductCard}
                        width='100'
                        height='100'
                        imagemBackgroundDefault={'340x340'}
                        value={cardsProduct[1] && cardsProduct[1].image ? cardsProduct[1].image : null}
                        change={(value: any) => {
                          Swal.fire({
                            title: 'Deseja Remover produto?',
                            text: '',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Sim, remover!',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setIsLoading(true)
                              cardsProduct[1] = {
                                image: '',
                                value: '',
                                description: '',
                              }
                              setTimeout(() => setIsLoading(false), 500)
                            }
                          })
                        }}
                        action={() => {
                          showWrapperModal('Imagem - Card Produto')
                          setCardProduct(cardsProduct[1])
                          setCardProductIndex(1)
                        }}
                      />
                      <ImageLoadingOverlay isLoading={imageLoadingState.product1} />
                    </div>
                    <div style={{ position: 'relative' }}>
                      <Input
                        inputAttr={{
                          type: 'image_modal',
                        }}
                        disabled={hasProductCard}
                        width='100'
                        height='100'
                        imagemBackgroundDefault={'340x340'}
                        value={cardsProduct[2] && cardsProduct[2].image ? cardsProduct[2].image : null}
                        change={(value: any) => {
                          Swal.fire({
                            title: 'Deseja Remover produto?',
                            text: '',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Sim, remover!',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setIsLoading(true)
                              cardsProduct[2] = {
                                image: '',
                                value: '',
                                description: '',
                              }
                              setTimeout(() => setIsLoading(false), 500)
                            }
                          })
                        }}
                        action={() => {
                          showWrapperModal('Imagem - Card Produto')
                          setCardProduct(cardsProduct[2])
                          setCardProductIndex(2)
                        }}
                      />
                      <ImageLoadingOverlay isLoading={imageLoadingState.product2} />
                    </div>
                    <div style={{ position: 'relative' }}>
                      <Input
                        inputAttr={{
                          type: 'image_modal',
                        }}
                        disabled={hasProductCard}
                        width='100'
                        height='100'
                        imagemBackgroundDefault={'340x340'}
                        value={cardsProduct[3] && cardsProduct[3].image ? cardsProduct[3].image : null}
                        change={(value: any) => {
                          Swal.fire({
                            title: 'Deseja Remover produto?',
                            text: '',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Sim, remover!',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setIsLoading(true)
                              cardsProduct[3] = {
                                image: '',
                                value: '',
                                description: '',
                              }
                              setTimeout(() => setIsLoading(false), 500)
                            }
                          })
                        }}
                        action={() => {
                          showWrapperModal('Imagem - Card Produto')
                          setCardProduct(cardsProduct[3])
                          setCardProductIndex(3)
                        }}
                      />
                      <ImageLoadingOverlay isLoading={imageLoadingState.product3} />
                    </div>
                    <div style={{ position: 'relative' }}>
                      <Input
                        inputAttr={{
                          type: 'image_modal',
                        }}
                        disabled={hasProductCard}
                        width='100'
                        height='100'
                        imagemBackgroundDefault={'340x340'}
                        value={cardsProduct[4] && cardsProduct[4].image ? cardsProduct[4].image : null}
                        change={(value: any) => {
                          Swal.fire({
                            title: 'Deseja Remover produto?',
                            text: '',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Sim, remover!',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setIsLoading(true)
                              cardsProduct[4] = {
                                image: '',
                                value: '',
                                description: '',
                              }
                              setTimeout(() => setIsLoading(false), 500)
                            }
                          })
                        }}
                        action={() => {
                          showWrapperModal('Imagem - Card Produto')
                          setCardProduct(cardsProduct[4])
                          setCardProductIndex(4)
                        }}
                      />
                      <ImageLoadingOverlay isLoading={imageLoadingState.product4} />
                    </div>
                  </div>
                </div>

                <div className='d-flex  gap-5 justify-content-between mt-5'>
                  <LittleButton
                    text={'voltar'}
                    color={'info'}
                    click={() => backPage()}
                    width='110px'
                    height='35px'
                  />

                  <LittleButton
                    text={'Próximo'}
                    color={'primary'}
                    click={() => nextPage()}
                    width='110px'
                    height='35px'
                  />
                </div>
              </div>
            </div>

            <ModalWrapper
              confirmAction={() => {
                const newCardsProduto = cardsProduct
                newCardsProduto[cardProductIndex] = cardProduct

                setCardsProduct(newCardsProduto)
                setCardProduct({})
              }}
              maxWidth={true}
              width={50}
            >
              <div
                className='d-flex  flex-column gap-5 card'
                style={{
                  height: '40rem',
                }}
              >
                <div className='card-body d-flex justify-content-between'>
                  <div className='d-flex  flex-column gap-5'>
                    <div>
                      <Input
                        inputAttr={{
                          type: 'default',
                        }}
                        value={data.name}
                        disabled={true}
                        change={() => { }}
                      />
                    </div>
                    <Input
                      inputAttr={{
                        type: 'textarea',
                      }}
                      label='Descrição- Resumo sobre o card do produto'
                      placeholder='A Descrição deva ter no máximo 80 caracteres.'
                      maxLength='80'
                      rows={5}
                      value={cardProduct && cardProduct.description}
                      change={(value: string) => {
                        const newCardProduto = { ...cardProduct }
                        newCardProduto.description = value
                        setCardProduct(newCardProduto)
                      }}
                    />
                    <Input
                      inputAttr={{
                        type: 'money',
                      }}
                      currency='BRL'
                      locale='pt-BR'
                      label='Valor do produto'
                      value={cardProduct && cardProduct.value}
                      change={(value: string) => {
                        const newCardProduto = { ...cardProduct }
                        newCardProduto.value = value

                        setCardProduct(newCardProduto)
                      }}
                    />
                    <Input
                      inputAttr={{
                        type: 'text',
                        maxLength: 350,
                      }}
                      label='URL Externa'
                      placeholder={'http:// ou https://'}
                      value={cardProduct && cardProduct.urlExternal}
                      change={(value: string) => {
                        const newCardProduto = { ...cardProduct }
                        newCardProduto.urlExternal = value
                        setCardProduct(newCardProduto)
                      }}
                    />
                    {cardProduct?.urlExternal && !validateUrl(cardProduct?.urlExternal) && (
                      <small className='text-danger mt-1 d-block'>
                        O link deve começar com http:// ou https://
                      </small>
                    )}
                  </div>

                  <Input
                    inputAttr={{
                      type: 'image',
                    }}
                    width='250'
                    height='250'
                    value={cardProduct && cardProduct.image}
                    change={(value: BaseSyntheticEvent) => {
                      const file = value ? value.target.files[0] : null;
                      const sizeInBytes: number = file ? file.size : 0;

                      const sizeInKB = parseFloat((sizeInBytes / 1024).toFixed(2));
                      const sizeInMB = parseFloat((sizeInKB / 1024).toFixed(2));

                      if (sizeInMB > 2) {
                        Swal.fire({
                          icon: 'error',
                          title: 'Erro',
                          text: 'O tamanho do arquivo excede 2MB. Por favor, selecione um arquivo menor.',
                        });
                        return;
                      }

                      const newCardProduto = { ...cardProduct }
                      newCardProduto.image = value ? value.target.files[0] : null

                      setCardProduct(newCardProduto)
                    }}
                  />
                </div>
              </div>
            </ModalWrapper>
          </div>
        )}
    </>
  )
}

export { ImagensLoja }
